import React from "react";
import { Tag } from "antd";
import { CalendarOutlined, RightOutlined } from "@ant-design/icons";
import { formatSearchDate } from "../search/searchResultUtils";

const STATUS_COLORS = {
  scheduled: "blue",
  confirmed: "cyan",
  completed: "green",
  cancelled: "red",
  no_show: "orange",
  rescheduled: "purple",
  expired: "volcano",
};

function Fact({ children }) {
  if (children == null || children === "") return null;
  return <span className="listing-card__fact">{children}</span>;
}

function patientName(record) {
  return (
    record?.patient_name ||
    [record?.first_name, record?.surname].filter(Boolean).join(" ") ||
    "—"
  );
}

/**
 * Compact linear appointment card for search results.
 */
export function AppointmentListingCard({ record, actions, onClick }) {
  const status = String(record?.status || "scheduled").toLowerCase();

  return (
    <article
      className="listing-card listing-card--linear search-result-card"
      onClick={onClick}
      onKeyDown={onClick ? (e) => e.key === "Enter" && onClick() : undefined}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      <div className="listing-card__lead">
        <div className="listing-card__icon is-appointment">
          <CalendarOutlined />
        </div>
        <div className="listing-card__identity">
          <h3 className="listing-card__title">{patientName(record)}</h3>
          <p className="listing-card__meta">{record?.insurance_no || "No insurance no"}</p>
        </div>
      </div>

      <div className="listing-card__facts">
        <Fact>{formatSearchDate(record?.scheduled_start)}</Fact>
        <Fact>{record?.facility_name}</Fact>
        {record?.converted_checkin_code ? (
          <Fact>Check-in {record.converted_checkin_code}</Fact>
        ) : null}
      </div>

      <div className="listing-card__aside" onClick={(e) => e.stopPropagation()}>
        <Tag color={STATUS_COLORS[status] || "default"} className="listing-card__tag">
          {status.replace("_", " ")}
        </Tag>
        {actions}
        {onClick ? <RightOutlined className="listing-card__chevron" aria-hidden /> : null}
      </div>
    </article>
  );
}
